<template>
  <section id="map-final" class="scrolly-overlay">
    <!-- sticky container -->
    <div class="scrolly__sticky" :class="{ interactive: step === '7-2'}">
      <!-- mapbox map -->
      <MapTerrain />

      <!-- ui instruction -->
      <PageInstruction v-show="step === '7-2'" />
    </div>

    <!-- steps container -->
    <v-container inner class="scrolly__text py-0">
      <v-layout wrap justify-center align-start class="step" style="height: 100%">
        <div class="text-block" data-step="7-1">
          <v-container>
            <h2 class="headline mb-3">What's next?</h2>

          	<p class="body-2">
              The BRI will take many years—if not decades—to complete. Whether it will ultimately be successful is yet to be determined, and one of the BRI’s greatest challenges is in winning the hearts and minds of local populaces. But it is apparent that the initiative is going to have massive global repercussions. This is because it is not only about infrastructure.  It has penetrated almost all sectors—education, tourism, commerce, and e-services, among other areas. At present, China is the new champion of global economic integration and trade. Any country that dismisses this paradigm shift will inevitably be disadvantaged.
          	</p>
          </v-container>
        </div>
      </v-layout>

      <v-layout justify-center align-end class="step">
        <div class="text-block" data-step="7-2" />
      </v-layout>

      <v-layout justify-center align-end class="step step--shorten">
        <div class="text-block" data-step="7-2" />
      </v-layout>

    </v-container>
  </section>
</template>

<script>
import * as d3 from 'd3';
import scrollama from 'scrollama';

import { mapGetters } from 'vuex';

// components
import PageInstruction from '@/components/scrolly/PageInstruction.vue';

import MapTerrain from '@/components/controllers/MapTerrain.vue';

export default {
  name: 'SectionMapFinal',
  components: {
    PageInstruction,
    MapTerrain,
  },
  computed: {
    ...mapGetters('view', ['step']),
  },
  mounted() {
    this.initScrollama();
  },
  methods: {
    initScrollama() {
      // instantiate scrollama
      const scrollerMapFinal = scrollama();

      // setup scrollama
      scrollerMapFinal
        .setup({
          container: '#map-final',
          graphic: '#map-final .scrolly__sticky',
          step: '#map-final .scrolly__text .step', // required
          offset: 64 / window.innerHeight, // after navbar height
        })
        .onStepEnter(this.handleStepEnter)
        .onStepExit(this.handleStepExit)
        .onContainerEnter(this.handleContainerEnter)
        .onContainerExit(this.handleContainerExit);
    },
    handleStepEnter(res) {
      // get data-step
      const currentStep = d3
        .select(res.element)
        .select('.text-block')
        .attr('data-step');

      // update view state
      this.$store.dispatch('view/updateStep', currentStep);
    },
    handleStepExit() {},
    handleContainerEnter({ direction }) {
      // update view state
      this.$store.dispatch('view/updatePage', 7);

      if (direction === 'down') {
        this.$store.dispatch('view/updateStep', '7-0');
      } else {
        this.$store.dispatch('view/updateStep', '7-2');
      }
    },
    handleContainerExit() {},
  },
};
</script>
